// ==================== Footer.js ====================
import React from 'react';
import { Zap } from 'lucide-react';


const Footer = () => (
  <footer className="bg-gray-900 text-white py-16">
    <div className="max-w-6xl mx-auto px-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-gradient-to-r from-purple-600 to-blue-600 rounded-xl flex items-center justify-center">
              <Zap size={24} />
            </div>
            <span className="text-2xl font-bold">ZenHire</span>
          </div>
          <p className="text-gray-400 mb-6 text-lg">Where hiring meets zen</p>
          <p className="text-gray-500 text-sm">© 2025 ZenHire. Helping Gen Z land their dream jobs.</p>
        </div>
        
        <div>
          <h4 className="font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-gray-400">
            <li><a href="/" className="hover:text-white transition-colors">About</a></li>
            <li><a href="/" className="hover:text-white transition-colors">Careers</a></li>
            <li><a href="/" className="hover:text-white transition-colors">Contact</a></li>
          </ul>
        </div>
        
        <div>
          <h4 className="font-semibold mb-4">Legal</h4>
          <ul className="space-y-2 text-gray-400">
            <li><a href="/" className="hover:text-white transition-colors">Privacy Policy</a></li>
            <li><a href="/" className="hover:text-white transition-colors">Terms of Service</a></li>
            <li><a href="/" className="hover:text-white transition-colors">Cookie Policy</a></li>
            <l1><a href="/contract" className="hover:text-white transition-colors">Contract</a></l1>
          </ul>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;